import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {
  HttpClientModule,
  HttpUrlEncodingCodec,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChartsModule } from 'ng2-charts';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgSelectModule } from '@ng-select/ng-select';

import { HttpErrorInterceptor } from './../app/_helpers/http-error.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ContentComponent } from './components/content/content.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { OrderComponent } from './components/order/order.component';
import { ManageComponent } from './components/manage/manage.component';
import { ManageservicesComponent } from './components/manage/manage-services.component';
import { ManageuserComponent } from './components/manage/manage-user.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { ReturnComponent } from './components/return/return.component';
import { ReportpartnerComponent } from './components/reportpartner/reportpartner.component';
import { UserpartnerComponent } from './components/userpartner/userpartner.component';
import { ViewuserComponent } from './components/viewuser/viewuser.component';
import { ViewserviceComponent } from './components/viewservice/viewservice.component';
import { CustomerComponent } from './components/customer/customer.component';
import { CustomerviewComponent } from './components/customer/customer-view.component';
import { CustomerserviceComponent } from './components/customer/customer-service.component';
import { SetcustomerComponent } from './components/setcustomer/setcustomer.component';
import { HomeComponent } from './components/home/home.component';
import { JwPaginationComponent } from 'jw-angular-pagination';
import { StokstbComponent } from './components/stokstb/stokstb.component';
import { PartnerComponent } from './components/partner/partner.component';
import { PartnerservicequotaComponent } from './components/partner/partner-servicequota.component';

import { SingleviewComponent } from './components/singleview/singleview.component';
import { ProductsComponent } from './components/products/products.component';
import { ProductvoucherComponent } from './components/products/productvoucher.component';
import { ProductvoucherbatchdetailComponent } from './components/products/productvoucherbatchdetail.component';
import { ProductvoucherlistComponent } from './components/products/productvoucherlist.component';
import { ProductvoucherbatchlistComponent } from './components/products/productvoucherbatchlist.component';
import { ProductvoucherordermanualComponent } from './components/products/productvoucherordermanual.component';

import { OrderserviceComponent } from './components/orderservice/orderservice.component';
import { EditpartnerComponent } from './components/editpartner/editpartner.component';
import { OrderservicecreateComponent } from './components/orderservice/orderservicecreate.component';
import { AdminpartnerComponent } from './components/adminpartner/adminpartner.component';
import { AdminpartnerServComponent } from './components/adminpartner/adminpartner-serv.component';
import { AdminpartnerQuotaComponent } from './components/adminpartner/adminpartner-quota.component';
import { AdminpartnerCustComponent } from './components/adminpartner/adminpartner-cust.component';
import { AdminpartnerListstbComponent } from './components/adminpartner/adminpartner-liststb.component';
import { AdminpartnerRekapdataComponent } from './components/adminpartner/adminpartner-rekapdata.component';

import { AdminsalesComponent } from './components/adminsales/adminsales.component';
import { AdminsalesStbComponent } from './components/adminsales/adminsales-stb.component';
import { AdminsalesServComponent } from './components/adminsales/adminsales-serv.component';
import { AdminsalesOrderstbComponent } from './components/adminsales/adminsales-orderstb.component';
import { AdminsalesOrderservComponent } from './components/adminsales/adminsales-orderserv.component';
import { AdminsalesListorderComponent } from './components/adminsales/adminsales-listorder.component';
import { AdminsalesViewComponent } from './components/adminsales/adminsales-view.component';
import { PartnerFormComponent } from './components/partner/partner-form.component';
import { AdminwicComponent } from './components/adminwic/adminwic.component';
import { AdminwicCustComponent } from './components/adminwic/adminwic-cust.component';
import { AdminwicListstbComponent } from './components/adminwic/adminwic-liststb.component';
import { AdminwicWicstbComponent } from './components/adminwic/adminwic-wicstb.component';
import { ListstbComponent } from './components/liststb/liststb.component';
import { PartnerListstbComponent } from './components/partner/partner-liststb.component';
import { MaintenancePartnerComponent } from './components/maintenance/maintenance-partner.component';
import { AdminpartnerPendingComponent } from './components/adminpartner/adminpartner-pending.component';
import { AdminactivationComponent } from './components/adminactivation/adminactivation.component';
import { AdminactivationViewComponent } from './components/adminactivation/adminactivation-view.component';
import { AddservicebulkyComponent } from './components/manage/addservicebulky.component';

import { OrderListComponent } from './components/order/order-list.component';
// import { OrderViewComponent } from './components/order/order-view.component';
import { ManageProvComponent } from './components/manage/manage-prov.component';
import { AdmincallcenterComponent } from './components/admincallcenter/admincallcenter.component';
import { AdminCCManageComponent } from './components/admincallcenter/manage-service.component';
import { AdminCCCustomerComponent } from './components/admincallcenter/customer-cc.component';
import { AdminCCActivationComponent } from './components/admincallcenter/activation-cc.component';
import { AdminsuperbranchComponent } from './components/adminsuperbranch/adminsuperbranch.component';
import { AdminsbManageComponent } from './components/adminsuperbranch/adminsb-manage.component';
import { AdminsbCustomerComponent } from './components/adminsuperbranch/adminsb-customer.component';
import { AdminsbMaintenanceComponent } from './components/adminsuperbranch/adminsb-maintenance.component';
import { AdminsbListstbComponent } from './components/adminsuperbranch/adminsb-liststb.component';
import { AdminsbSbstbComponent } from './components/adminsuperbranch/adminsb-sbstb.component';
import { AdminsalesChangeComponent } from './components/adminsales/adminsales-change.component';
import { AdminsalesServicequotaComponent } from './components/adminsales/adminsales-servicequota.component';
import { AdminsalesChangeserviceComponent } from './components/adminsales/adminsales-changeservice.component';
import { AdminlogisticComponent } from './components/adminlogistic/adminlogistic.component';
import { AdminlogListstbComponent } from './components/adminlogistic/adminlog-liststb.component';
import { AdminlogViewComponent } from './components/adminlogistic/adminlog-view.component';
import { AdminsalesOrderstbonlyComponent } from './components/adminsales/adminsales-orderstbonly.component';
import { AdminsalesListorderstbonlyComponent } from './components/adminsales/adminsales-listorderstbonly.component';
// import { AdminwicCustreportComponent } from './components/adminwic/adminwic-custreport.component';
import { AdminrevaComponent } from './components/adminreva/adminreva.component';
import { AdminrevaCustreportComponent } from './components/adminreva/adminreva-custreport.component';
import { AdminrevaSummarycicilanComponent } from './components/adminreva/adminreva-summarycicilan.component';
import { AdminrevaSummarycicilanagingComponent } from './components/adminreva/adminreva-summarycicilanaging.component';

import { ReleasestbComponent } from './components/releasestb/releasestb.component';
import { RequestreleaseComponent } from './components/releasestb/requestrelease.component';
import { ReleasestbViewComponent } from './components/releasestb/releasestb-view.component';

import { ListorderComponent } from './components/adminecommerceold/listorder.component';
import { OrderviewComponent } from './components/adminecommerceold/order-view.component';

import { MarketplaceformComponent } from './components/adminecommerceold/marketplace-form.component';

import { PurchaseComponent } from './components/purchase/purchase.component';

import { OperationComponent } from './components/operation/operation.component';
import { TestareaComponent } from './components/operation/testarea.component';
import { NotificationComponent } from './components/operation/notification/notification.component';
import { CancelComponent } from './components/operation/cancelcustomer/cancel.component';
import { UpdatepaytvComponent } from './components/operation/updatepaytv/updatepaytv.component';

import { AdminpartnerNotifComponent } from './components/adminpartner/adminpartner-notif.component';
import { PlayboxComponent } from './components/playbox/playbox.component';
import { InformationComponent } from './components/playbox/information.component';
import { MessageComponent } from './components/playbox/message.component';
import { PromoComponent } from './components/promo/promo.component';
import { RunningtextComponent } from './components/playbox/runningtext.component';

import { AdminapComponent } from './components/adminap/adminap.component';
import { AdminapviewComponent } from './components/adminap/adminap-view.component';
import { AdminapverifiedComponent } from './components/adminap/adminap-verified.component';

import { AdminapecommerceComponent } from './components/adminap/adminap-ecommerce.component';
import { AdminapverifiedecommerceComponent } from './components/adminap/adminap-verifiedecommerce.component';
import { AdminapviewecommerceComponent } from './components/adminap/adminap-viewecommerce.component';

/* dismantle */
import { AdmindismantleComponent } from './components/admindismantle/admindismantle.component';

import { AdminvoucherListtransaksiComponent } from './components/adminvoucher/adminvoucher-listtransaksi.component';
import { AdminvoucherlistComponent } from './components/adminvoucher/adminvoucherlist.component';
import { AdminvoucherProductsComponent } from './components/adminvoucher/adminvoucher-products.component';
import { ManageProvFormComponent } from './components/manage/manage-prov-form.component';
import { ListStoreshopComponent } from './components/adminecommerceold/storeshop/list-storeshop.component';
import { FormStoreshopComponent } from './components/adminecommerceold/storeshop/form-storeshop.component';
import { AdminrevaDetailCicilanComponent } from './components/adminreva/adminreva-detail-cicilan.component';
import { AdminrevaDetailOutstandingComponent } from './components/adminreva/adminreva-detail-outstanding.component';
import { AdminrevaDaftarPelangganCicilanComponent } from './components/adminreva/adminreva-daftar-pelanggan-cicilan.component';

import { AppsListComponent } from './components/cgmn/apps-list.component';
import { MasterThemeComponent } from './components/cgmn/master-theme.component';
import { MasterPackageComponent } from './components/cgmn/master-package.component';
import { ChannelListComponent } from './components/cgmn/channel-list.component';

import { AdminNextsysListOrderStbComponent } from './components/adminnextsys/adminnextsys-listorderstb.component';
import { AdminNextsysListOrderStbDetailComponent } from './components/adminnextsys/adminnextsys-listorderstb-detail.component';
import { AdminNextsysOrderStbComponent } from './components/adminnextsys/adminnextsys-orderstb.component';

import { PartnerNextsysComponent } from './components/partnernextsys/partnernextsys.component';
import { PartnerNextsysListStbComponent } from './components/partnernextsys/partnernextsys-liststb.component';
import { ListstbnextsysComponent } from './components/liststbnextsys/liststbnextsys.component';
import { ManageusernextsysComponent } from './components/manage/manage-user-nextsys.component';
import { PartnerNextsysFormComponent } from './components/partnernextsys/partnernextsys-form.component';
import { AdminNextsysChangeLauncherComponent } from './components/adminnextsys/adminnextsys-change-launcher.component';
import { ListpackagenextsysComponent } from './components/listpackagenextsys/listpackagenextsys.component';

import { FormOrderComponent } from './components/adminecommerce/formorder.component';
import { ListOrderComponent } from './components/adminecommerce/listorder.component';
import { OrderViewComponent } from './components/adminecommerce/order-view.component';
import { IsporderComponent } from './components/isporder/isporder.component';
import {CurrencyPipe} from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';

import { LauncherVersionComponent } from './components/cgmn/launcher-version.component';
import { MasterChannelComponent } from './components/cgmn/master-channel.component';
import { AdminNextsysManageServiceSTBComponent } from './components/adminnextsys/adminnextsys-manage-service-stb.component';
import { AdminNextsysManageServiceSTBDetailComponent } from './components/adminnextsys/adminnextsys-manage-service-stb-detail.component';
import { AdminNextsysManageServiceComponent } from './components/adminnextsys/adminnextsys-manage-service.component';

import { CgmnNotificationComponent } from './components/adminnextsys/notification.component';

import { MessageTemplateComponent } from './components/cgmn/message-template.component';
import { ResetstbnextsysComponent } from "./components/resetstbnextsys/resetstbnextsys.component";


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavbarComponent,
    ContentComponent,
    FooterComponent,
    LoginComponent,
    DashboardComponent,
    OrderComponent,
    ManageComponent,
    ManageservicesComponent,
    ManageuserComponent,
    MaintenanceComponent,
    ReturnComponent,
    ReportpartnerComponent,
    UserpartnerComponent,
    ViewuserComponent,
    ViewserviceComponent,
    CustomerComponent,
    CustomerviewComponent,
    CustomerserviceComponent,
    SetcustomerComponent,
    HomeComponent,
    JwPaginationComponent,
    StokstbComponent,
    PartnerComponent,
    PartnerservicequotaComponent,
    SingleviewComponent,
    ProductsComponent,
    ProductvoucherComponent,
    ProductvoucherbatchdetailComponent,
    ProductvoucherlistComponent,
    ProductvoucherbatchlistComponent,
    ProductvoucherordermanualComponent,

    OrderserviceComponent,
    EditpartnerComponent,
    OrderservicecreateComponent,
    AdminpartnerComponent,
    AdminpartnerServComponent,
    AdminpartnerQuotaComponent,
    AdminpartnerCustComponent,
    AdminpartnerListstbComponent,
    AdminpartnerRekapdataComponent,
    AdminsalesComponent,
    AdminsalesStbComponent,
    AdminsalesServComponent,
    AdminsalesOrderstbComponent,
    AdminsalesOrderservComponent,
    AdminsalesListorderComponent,
    AdminsalesViewComponent,
    PartnerFormComponent,
    AdminwicComponent,
    AdminwicCustComponent,
    AdminwicListstbComponent,
    AdminwicWicstbComponent,
    ListstbComponent,
    PartnerListstbComponent,
    MaintenancePartnerComponent,
    AdminpartnerPendingComponent,
    AdminactivationComponent,
    AdminactivationViewComponent,
    AddservicebulkyComponent,
    OrderListComponent,
    OrderViewComponent,
    MarketplaceformComponent,

    ManageProvComponent,
    AdmincallcenterComponent,
    AdminCCManageComponent,
    AdminCCCustomerComponent,
    AdminCCActivationComponent,
    AdminsuperbranchComponent,
    AdminsbManageComponent,
    AdminsbCustomerComponent,
    AdminsbMaintenanceComponent,
    AdminsbListstbComponent,
    AdminsbSbstbComponent,
    AdminsalesChangeComponent,
    AdminsalesServicequotaComponent,
    AdminsalesChangeserviceComponent,
    AdminlogisticComponent,
    AdminlogListstbComponent,
    AdminlogViewComponent,
    AdminsalesOrderstbonlyComponent,
    AdminsalesListorderstbonlyComponent,
    //   AdminwicCustreportComponent,
    AdminrevaComponent,
    AdminrevaCustreportComponent,
    AdminrevaSummarycicilanComponent,
    AdminrevaSummarycicilanagingComponent,
    ReleasestbComponent,
    RequestreleaseComponent,
    ReleasestbViewComponent,
    ListorderComponent,
    OrderviewComponent,
    PurchaseComponent,
    OperationComponent,
    TestareaComponent,
    NotificationComponent,
    CancelComponent,
    UpdatepaytvComponent,
    AdminpartnerNotifComponent,
    PlayboxComponent,
    InformationComponent,
    MessageComponent,
    PromoComponent,
    RunningtextComponent,
    AdminapComponent,
    AdminapviewComponent,
    AdminapverifiedComponent,
    AdminapecommerceComponent,
    AdminapverifiedecommerceComponent,
    AdminapviewecommerceComponent,
    AdmindismantleComponent,
    AdminvoucherListtransaksiComponent,
    AdminvoucherlistComponent,
    AdminvoucherProductsComponent,
    ManageProvFormComponent,
    ListStoreshopComponent,
    FormStoreshopComponent,
    AdminrevaDetailCicilanComponent,
    AdminrevaDetailOutstandingComponent,
    AdminrevaDaftarPelangganCicilanComponent,

    AppsListComponent,
    MasterThemeComponent,
    MasterPackageComponent,

    AdminNextsysListOrderStbComponent,
    AdminNextsysListOrderStbDetailComponent,
    AdminNextsysOrderStbComponent,
    AdminNextsysChangeLauncherComponent,
    AdminNextsysManageServiceComponent,
    AdminNextsysManageServiceSTBComponent,
    AdminNextsysManageServiceSTBDetailComponent,

    PartnerNextsysComponent,
    PartnerNextsysFormComponent,
    PartnerNextsysListStbComponent,
    ListstbnextsysComponent,
    ManageusernextsysComponent,

    ListpackagenextsysComponent,

    FormOrderComponent,
    ListOrderComponent,
    OrderViewComponent,
    IsporderComponent,

    LauncherVersionComponent,
    MasterChannelComponent,
    ChannelListComponent,

    CgmnNotificationComponent,

    MessageTemplateComponent,
    ResetstbnextsysComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ChartsModule,
    TooltipModule,
    NgSelectModule,
    QRCodeModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    CurrencyPipe
  ],
  bootstrap: [AppComponent],
  exports: [AppComponent],
})
export class AppModule { }
